import { BrowserRouter } from 'react-router-dom'
import { AppRouter } from './router'
import { ErrorBoundary } from './ErrorBoundary'
import { Toaster } from '@/components/ui/Toaster'

export function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <AppRouter />
        <Toaster />
      </BrowserRouter>
    </ErrorBoundary>
  )
}
